import {useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import _ from "lodash"
import {Empty, Modal, notification} from "antd";
import {
	Button,
	Loading,
	Icon
} from "~/components";
import ActionBar from "~/layout/ActionBar";
import {
	handleRequest,
	apiError,
} from "~/utils";
import {
	useCan
} from "~/hooks";
import {
	productApi
} from "~/api";
import {
	ProductSearchBar,
	ProductTable,
} from "../components";
import {
	productActions,
	productErrorSelector,
	productFilterSelector,
	productItemsSelector,
	productLoadingSelector,
	productPaginationSelector
} from "../../../reduxs/Product/productSlice";

function Product()
{
	const can = {
	    add : useCan('products_add'),
	    edit : useCan('products_edit'),
	    delete : useCan('products_delete')
	}

	const navigate = useNavigate();
	const dispatch  = useDispatch();

	const items     = useSelector(productItemsSelector);
	const loading   = useSelector(productLoadingSelector);
	const error     = useSelector(productErrorSelector);
	const pagination = useSelector(productPaginationSelector);
	const filter    = useSelector(productFilterSelector);

	const [itemEdit, setItemEdit] = useState({});

	//Model
	const [openModal, setOpenModal] = useState({
		delete      : false,
	});

	const eventHandlers =
	{
		openModal : useCallback((modal) =>
		{
			setOpenModal(prev => ({ ...prev, [modal]: true }));
		}, []),

		closeModal : useCallback((modal) =>
		{
			setOpenModal(prev => ({ ...prev, [modal]: false }));
		}, []),

		load: useCallback(() =>
		{
			dispatch(productActions.fetchData(filter));
		}, [dispatch, filter]),

		paginationChange: (page) =>
		{
			dispatch(productActions.setFilter({...filter, page }));
		},

		search: (newFilter) =>
		{
			dispatch(productActions.setFilterWithDebounce(newFilter));
		},

		filterChange: (key, value) =>
		{
			const newFilter = {
				...filter,
				[key]: value,
				page: 1
			};
			dispatch(productActions.setFilter(newFilter));
		},

		add: () =>
		{
			navigate('/product/add');
		},

		edit: async (item) =>
		{
			if (!item?.id)
			{
				notification.error({message: 'Lỗi', description: 'Không có thông tin sản phẩm để cập nhật'});
				return;
			}

			navigate(`/product/edit/${item.id}`);
		},

		deleteConfirm: (item) =>
		{
			setItemEdit(item);
			eventHandlers.openModal('delete');
		},

		//Delete
		delete: async () =>
		{
			if (!itemEdit?.id)
			{
				notification.error({message: 'Lỗi', description: 'Không có thông tin sản phẩm để xóa'});
				return;
			}

			let [error, response] = await handleRequest(productApi.delete(itemEdit.id));

			if(!apiError(`Xóa sản phẩm thất bại`, error, response))
			{
				notification.success({message: 'Thành công', description: `Xóa sản phẩm thành công`});

				dispatch(productActions.delete(itemEdit.id));

				eventHandlers.closeModal('delete')
			}
		}
	}

	//Load data
	useEffect(() =>
	{
		let isMounted = true;
		if (isMounted) eventHandlers.load();
		return () => { isMounted = false };
	}, [filter]);

	return (
		<>
			<ActionBar title={'Sản phẩm'}>
				{can.add && <Button outline leftIcon={Icon.plusCircle} onClick={eventHandlers.add}>Thêm mới</Button>}
				<Button outline onClick={eventHandlers.load}>{Icon.reload}</Button>
			</ActionBar>
			<div className="container">
				<div className="content p-2">
					{loading && <Loading/>}
					{<ProductSearchBar filter={filter} onSearchChange={eventHandlers.search} onChange={eventHandlers.filterChange} can={can} />}
					{_.isEmpty(items) && <Empty />}
					{!_.isEmpty(items) && <ProductTable
							items={items}
							pagination={pagination}
							onPaginationChange={eventHandlers.paginationChange}
							onEdit={eventHandlers.edit}
							onDelete={eventHandlers.deleteConfirm}
							can={can}
					/>}
				</div>
				{
					(can.delete && itemEdit?.id) && <Modal
						title="Xóa sản phẩm"
						open={openModal.delete}
						onOk={eventHandlers.delete}
						okType={'danger'}
						onCancel={() => {eventHandlers.closeModal('delete')}}
					>
						<p>Bạn muốn xóa sản phẩm <b>{itemEdit?.title}</b>?</p>
					</Modal>
				}
			</div>
		</>
	)
}

export default Product;
